import { atom } from "jotai";

export const leadsAtom = atom([]);
export const isListInitAtom = atom(false);
export const isSearchingAtom = atom(false);
export const leadCountAtom = atom(0);
export const isExportingAllAtom = atom(false);
export const exportProgressAtom = atom({ current: 0, total: 0 });

export const leadsFiltersAtom = atom({
  page: 1,
  filters: {
    terms: "",
    products: [],
    assignedTo: [],
    statuses: [],
    beginAt: "",
    endAt: "",
    producer: "",
    onlyFinalized: false,
    prochaineTache: "",
  },
});
